import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { GlobalStateService } from '../services/global/global-state.service';

@Injectable({
  providedIn: 'root'
})
export class PermissionGuard implements CanActivate {

  constructor(
    private globalStateService: GlobalStateService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {

    // Get the route path to check permission
    const routePath = route.routeConfig?.path || '';

    return this.globalStateService.user.pipe(
      take(1),
      map(user => {
        // If no user, redirect to login
        if (!user) {
          this.router.navigate(['/login']);
          return false;
        }

        // If user is admin, allow access
        if (user?.role_complete?.is_admin) {
          return true;
        }

        // Check if user has view permission for this route
        const hasPermission = user?.role_complete?.permissions?.[routePath]?.view;

        if (hasPermission) {
          return true;
        } else {
          // Redirect to 403 forbidden page
          this.router.navigate(['/403']);
          return false;
        }
      })
    );
  }
}

